<template>
    <div class="item-question-terms">
        <div class="d-flex flex-row">
            <label v-if="numberContent != '' && question.placeholder == false" class="text-color-number mb-1">
                {{ numberContent }}
            </label>
            <label class="text-color-questions mb-1 ps-2"
                   v-if="question.placeholder == false"
                   v-html="labelContent">
            </label>
        </div>
        <div v-if="question.additionalInfo != ''" id="qdesc" class="description content_terms_cond" v-html="question.additionalInfo">
        </div>
        <check-input :error-text="translate('label.this_value_is_required')"
                     :field-id="question.questionId"
                     :input-class="'form-check-input question-input-check'"
                     :name="'question_' + TYPE_FIELD_ID + '_' + question.questionId + '_' + question.fieldType"
                     :options="options"
                     :other-text="translateLabels.textOther"
                     :question="question"
                     :type="'check'"
                     :type-field-id="TYPE_FIELD_ID"
                     :validation="validationRules"
                     :has-submitted="hasSubmitted"
                     @update:modelAnswer="changeValue($event, question)"
                     @register-field="handleFieldRegister"
                     @field-change="handleFieldChange" />
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import CheckInput from "../components/check-input.vue";
import { useTranslation } from '@/composables/useTranslation';

// INITIALIZE STORE & COMPOSABLES
const { translate } = useTranslation();
const playerStore = usePlayerStore();

// PROPS & EMITS
const props = defineProps({
    enumeration: {
        type: Number,
        required: false,
        default: 0,
    },
    question: {
        type: Object,
        required: true,
    },
    showNumbering: {
        type: Boolean,
        required: false,
        default: false,
    },
    translateLabels: {
        type: Object,
        required: true,
    },
    TYPE_FIELD_ID: {
        type: Number,
        required: true,
    },
    hasSubmitted: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['field-change', 'register-field']);

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const fieldName = computed(() =>
    `question_${props.TYPE_FIELD_ID}_${props.question.questionId}_${props.question.fieldType}`
);

const validationRules = computed(() => {
    const rules = {
        required: false,
    };
    if (props.question.required) {
        rules.required = true;
    }

    return rules;
});

const labelContent = computed(() => {
    if (Boolean(props.question.required)) {
        return `* ${props.question.description}`;
    }
    return props.question.description;
});

const numberContent = computed(() => {
    const label = [];

    if (Boolean(props.showNumbering)) {
        label.push(`${String(props.enumeration).padStart(2, '0')}.`);
    }

    return label.join(' ');
});

const options = computed(() => {
    let options = {};
    let textOther = props.translateLabels.textOther;
    props.question.options.forEach(function (element) {
        let value = element.optionId;
        let label = String(element.description);
        if (element.other === true) {
            otherId.value = parseInt(value);
            value = 'other';
            label = textOther;
        }
        options[value] = {
            'label': label,
            'additionalInfo': element.additionalInfo || '',
        }
    });
    return options;
});

/*const elementNumber = computed(() => {
    return `${props.enumeration}.`;
});*/

// METHODS
const changeValue = (newValue, qt) => {
    qt.answer = newValue;
    emit('field-change', fieldName.value, newValue);
    playerStore.setAnswerInFormQuestions(qt);
};

const handleFieldRegister = (fieldName, initialValue) => {
    emit('register-field', fieldName, initialValue);
};

const handleFieldChange = (fieldName, value) => {
    emit('field-change', fieldName, value);
};

// LYFECYCLE HOOKS
onMounted(async () => {
    const initialValue = props.question.answer || [];
    emit('register-field', fieldName.value, initialValue);


    document.querySelectorAll('.open-popup-link').forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault()
            // 1. Definimos las dimensiones de tu popup
            const popupWidth = 1100;
            const popupHeight = 700;

            // 2. Calculamos la posición X (Left) e Y (Top) para el centro exacto de la pantalla
            const left = (window.screen.width / 2) - (popupWidth / 2);
            const top = (window.screen.height / 2) - (popupHeight / 2);

            window.open(link.href, 'Terms&Conditions',
                `width=${popupWidth},height=${popupHeight},top=${top},left=${left},scrollbars=yes,resizable=yes`)

        })
    })
});
</script>
